import {
  Typography,
  Avatar,
  List,
  ListItemAvatar,
  ListItemText,
  Paper,
  makeStyles,
  Grid,
} from "@material-ui/core";
import React from "react";
import { useHistory, useLocation } from "react-router-dom";
import { ItemsState } from "../../redux/state";
import { FindInPage } from "@material-ui/icons";
import { ListItem } from "@ofqual/portal-components/components/List/ListItem";
import { formatUtcDate, standardDateFormats} from "@ofqual/portal-core/core/utils/dateUtils";
import { CommissionStatus } from "../../domain/CommissionModel";
import { authSelector } from "../../redux/selectors";
import { useAuth } from "@ofqual/portal-core/core/hooks";


const SEARCH_STATE_KEY = "search";

const useStyles = makeStyles((theme) => ({
  active: {
    ...theme.list.itemPrimary,
  },
}));

export const ItemsList: React.FC<{ state: ItemsState }> = ({ state }) => {
  const classes = useStyles();

  const { response } = state;
  const history = useHistory();
  const { pathname, search } = useLocation();
  const navigate = (id: string) =>
    history.push(`${pathname}/${id}`, { [SEARCH_STATE_KEY]: search });

  const { experimentalFeatures } = useAuth(authSelector);

  
  return (
    <Grid item md={8}>
    <Paper>
      <List disablePadding>
        {response.data.map((item, index) => (
          <React.Fragment key={item.id}>
            <ListItem
              button
              alignItems="flex-start"
              onClick={() => experimentalFeatures !== undefined && !!experimentalFeatures.find(x => x.moduleName === "portal-commissions" && x.featureName === "portal-commissions-item")  && navigate(item.id)}
              divider
              className={classes.active}
              data-test="row"
              Icon={FindInPage}
              primaryText={item.referenceNumber + " " + item.title}

              secondaryDetails={[
                { heading: "Created by", value: item.createdByDisplayName },
                {
                  heading: "Created date",
                  value: formatUtcDate(
                    item.createdDate,
                    standardDateFormats.DATE_TIME
                  ),
                },
                {
                  heading: "Update date",
                  value: formatUtcDate(
                    item.modifiedDate,
                    standardDateFormats.DATE_TIME
                  ),
                },
              ]}
              chipTexts={[`Status: ${CommissionStatus[item.status]}`]}
            >
              <ListItemAvatar>
                <Avatar />
              </ListItemAvatar>
              <ListItemText
                primary={<span>{item.title}</span>}
                secondary={
                  <React.Fragment>
                    <Typography
                      component="span"
                      variant="subtitle1"
                      color="textPrimary"
                    ></Typography>
                    <br />
                  </React.Fragment>
                }
              />
            </ListItem>
          </React.Fragment>
        ))}
      </List>
      </Paper>
    </Grid>
  );
};
